import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Mail, Lock, AlertCircle } from 'lucide-react';

/**
 * Form di login (email + password). Presentational component.
 * Tutta la logica di auth resta nel parent (LoginPage).
 */
const LoginForm = ({ email, setEmail, password, setPassword, error, loading, onSubmit }) => (
  <form onSubmit={onSubmit} className="space-y-6">
    {error && (
      <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm" data-testid="login-error">
        <AlertCircle className="w-4 h-4" />
        {error}
      </div>
    )}

    <div className="space-y-2">
      <Label htmlFor="email" className="text-slate-700">Email</Label>
      <div className="relative">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input
          id="email"
          type="email"
          placeholder="nome@azienda.it"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="pl-10"
          required
          data-testid="login-email-input"
        />
      </div>
    </div>

    <div className="space-y-2">
      <Label htmlFor="password" className="text-slate-700">Password</Label>
      <div className="relative">
        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input
          id="password"
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="pl-10"
          required
          data-testid="login-password-input"
        />
      </div>
    </div>

    <Button
      type="submit"
      className="w-full bg-slate-900 hover:bg-slate-800"
      disabled={loading}
      data-testid="login-submit-btn"
    >
      {loading ? 'Accesso in corso...' : 'Accedi'}
    </Button>
  </form>
);

export default LoginForm;
